/*eslint-disable*/
import api from './';

class AuthApi {

    // POST: auth/login
    static getUserTokenByCredentials(credentials) {
        return api.axios.post('/auth/login', credentials)
            .then((response) => {
                return response.data.token;
            });
    }

    // POST: auth/forgot
    static forgotPassword(email) {
        return api.axios.post('/auth/restore-password', {email});
    }


    //POST: /auth/confirm-restore
    static restorePassword(data) {
        return api.axios.post('/auth/confirm-restore', data)
    }

    static register(data) {
        return api.axios.post('/auth/register', data)
    }
}

export default AuthApi;